export default __webpack_public_path__ + "media/images/landing-10-3554eb13097321266068ad9ee3d888db.jpg";